import React, { useState } from 'react';
import './index.scss';
import Section from 'Components/Section';
import iconMarkerUrl from 'Assets/icon/marker.svg';
import { useTranslation } from 'react-i18next';
import RadioSelectCard from 'Components/RadioSelectCard';
import infoCircleUrl from 'Assets/icon/info-circle.svg';
import classnames from 'Utilities/classnames';
import iconTakeOffPlaneUrl from 'Assets/icon/take-off-plane.svg'
import { useSelector } from 'react-redux';
import { orderBillSelectors } from 'Stores/order-bill';
import {addMinutes, format} from 'date-fns'
const TruckIcon = () => (
  <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="truck-icon-grad" x1="22.0799" y1="-5.30205e-05" x2="0.552422" y2="27.2878" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--s247-icon-start, #AA258D)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #EE5B33)"/>
      </linearGradient>
      <clipPath id="truck-icon-clip">
        <rect width="25" height="22" fill="white"/>
      </clipPath>
    </defs>
    <g clipPath="url(#truck-icon-clip)">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.9158 12.6923H3.89582C3.55355 12.6923 3.27652 12.4103 3.27759 12.0631V4.85991C3.27759 4.51266 3.55462 4.23071 3.89582 4.23071H12.9158C13.257 4.23071 13.534 4.51266 13.534 4.85991V12.0631C13.534 12.4103 13.257 12.6923 12.9158 12.6923ZM19.6814 6.7497L24.3399 11.2632C24.5266 11.4442 24.6338 11.6955 24.6349 11.9524V14.757C24.6349 14.7849 24.6281 14.8112 24.6159 14.8345C24.6289 14.8107 24.6365 14.7836 24.6372 14.7548V15.9723C24.6372 16.5095 24.1866 16.9462 23.6322 16.9462H20.8293H20.7636C20.6922 16.9462 20.6276 16.9049 20.6 16.8412C20.2001 15.9309 19.2815 15.3434 18.2615 15.3434C17.2416 15.3434 16.323 15.9309 15.9231 16.8412C15.8943 16.9049 15.8309 16.9462 15.7594 16.9462H15.6937H11.7303H11.6646C11.5931 16.9462 11.5286 16.906 11.5009 16.8424C11.101 15.9321 10.1824 15.3445 9.16248 15.3445C8.14251 15.3445 7.22396 15.9321 6.82404 16.8424C6.79523 16.906 6.73184 16.9474 6.66038 16.9474H6.59469H3.71226C3.15791 16.9474 2.70728 16.5106 2.70728 15.9734V14.757V14.7559V14.4845C2.70728 13.9473 3.15791 13.5105 3.71226 13.5105H13.935C14.2935 13.5105 14.585 13.2279 14.585 12.8806V7.43885C14.585 6.9016 15.0357 6.46488 15.59 6.46488H18.9703C19.2389 6.46488 19.4913 6.56541 19.6814 6.7497ZM18.6994 7.66782C18.8469 7.66782 18.991 7.72702 19.0935 7.8309L21.1842 9.95308C21.3375 10.1095 21.379 10.3284 21.2914 10.5261C21.2038 10.7238 21.0113 10.8466 20.79 10.8466H16.52C16.2192 10.8466 15.9749 10.6098 15.9749 10.3183V8.19614C15.9749 7.90461 16.2192 7.66782 16.52 7.66782H18.6994ZM7.64602 16.3911C8.02866 16.0058 8.56573 15.7656 9.16042 15.7656C9.75627 15.7656 10.2922 16.0058 10.6771 16.3911C11.0425 16.7586 11.2684 17.2568 11.2684 17.8074C11.2684 18.9355 10.3245 19.8492 9.16157 19.8492C7.99754 19.8492 7.05479 18.9344 7.05479 17.8074C7.05479 17.2568 7.28068 16.7586 7.64602 16.3911ZM8.0955 17.8074C8.0955 18.377 8.57264 18.8395 9.16042 18.8395C9.74935 18.8395 10.2253 18.377 10.223 17.8074C10.223 17.5293 10.1089 17.2769 9.92453 17.0914C9.73091 16.8971 9.46007 16.7754 9.15927 16.7754C8.85846 16.7754 8.58762 16.8971 8.394 17.0914C8.2096 17.2769 8.0955 17.5293 8.0955 17.8074ZM18.2582 15.7654C17.6635 15.7654 17.1265 16.0055 16.7438 16.3909C16.3785 16.7583 16.1526 17.2565 16.1526 17.8071C16.1526 18.9341 17.0953 19.8489 18.2594 19.8489C19.4223 19.8489 20.3662 18.9353 20.3662 17.8071C20.3662 17.2565 20.1403 16.7583 19.7749 16.3909C19.39 16.0055 18.8529 15.7654 18.2582 15.7654ZM18.2582 18.8392C17.6704 18.8392 17.1933 18.3768 17.1933 17.8071C17.1933 17.529 17.3074 17.2766 17.4918 17.0912C17.6854 16.8968 17.9563 16.7751 18.2571 16.7751C18.5579 16.7751 18.8287 16.8968 19.0223 17.0912C19.2067 17.2766 19.3208 17.529 19.3208 17.8071C19.322 18.3768 18.846 18.8392 18.2582 18.8392Z" fill="url(#truck-icon-grad)"/>
    </g>
  </svg>
);
import { DATE_FORMATS } from 'Utilities/constants';
import { newDateWithFormat, removeVietnameseTones } from 'Utilities/util';
import { tAirport } from '../../../localization';
import i18next from 'i18next';

enum DeliveryMethod {
	bySelf,
	byTruck
}

interface CommonTextBlockProps {
	text: string,
	subText: string,
	className?: string
}

const CommonTextBlock = (props: CommonTextBlockProps) => {
	const {
		text,
		subText,
		className
	} = props;

	const containerClasses = classnames(`d-flex flex-column`, className)

	return <div className={containerClasses}>
		<div className={'fs-p-md lh-p-md mb-1'}>{text}</div>
		<div className={'fs-p-md lh-p-md text-secondary'}>{subText}</div>
	</div>
}

interface DestinationBlockProps {
	deliveryMethod: DeliveryMethod
	onMethodChange: (method: DeliveryMethod) => void,
	selfMethodText: string,
	selfMethodCutOffTime: string,
	truckMethodText: string,
	airportLocation: string,
	airportName: string,
	className?: string
}

const DestinationInfoBlock = (props: DestinationBlockProps) => {
	const {
		deliveryMethod,
		onMethodChange,
		selfMethodCutOffTime,
		selfMethodText,
		truckMethodText,
		airportLocation,
		airportName,
		className
	} = props;
	const {t} = useTranslation();
	return <div className={className}>
		<CommonTextBlock className={'mb-3'} text={airportLocation} subText={airportName}/>
		<div className={'destination-info-options d-flex gap-6'}>
			<RadioSelectCard className={'flex-grow-1 destination-info-select'} checked={deliveryMethod === DeliveryMethod.bySelf} onChange={(val) => {
				if(!val) return;
				onMethodChange(DeliveryMethod.bySelf)
			}}>
				<div className={'fs-p-md lh-p-md mb-2'}>{selfMethodText}</div>
				<div className={'fs-p-lg lh-p-lg fw-600'}>{selfMethodCutOffTime}</div>
			</RadioSelectCard>
			<RadioSelectCard className={'destination-info-select flex-grow-1'} disabled checked={deliveryMethod === DeliveryMethod.byTruck} onChange={(val) => {
				if(!val) return;
				onMethodChange(DeliveryMethod.byTruck)
			}}>
				<div className={'fs-p-md lh-p-md mb-2'}>{truckMethodText}</div>
				<div className={'fs-p-lg lh-p-lg fw-600'}>{t('global_coming_soon_feature')}</div>
			</RadioSelectCard>
		</div>
	</div>
}

const RoadLineIllustration = () => {
	return (<div className={'road-line-illus'}>
		<div className={'road-line-illus-dot road-line-illus-dot--origin'}/>
		<div className={'road-line-illus-line'}/>
		<div className={'road-line-illus-dot road-line-illus-dot--destination'}/>
	</div>)
}

const SelectDeliveryMethod = () => {
	const {t} = useTranslation();
	const [departedMethod, setDepartedMethod] = useState<DeliveryMethod>(DeliveryMethod.bySelf);
	const [arrivalMethod, setArrivalMethod] = useState<DeliveryMethod>(DeliveryMethod.bySelf);
	const flightInfo = useSelector(orderBillSelectors.get).flightInfo;
	const flightFilter = useSelector(orderBillSelectors.get).flightFilter;

	if(!flightInfo || !flightFilter) return <></>

	const timeFormat = 'dd/MM/yyyy - HH:mm'

	const departureTime = newDateWithFormat(flightInfo.startTime, DATE_FORMATS.ISO_CUSTOM);
	const arrivalTime = newDateWithFormat(flightInfo.minEndTime, DATE_FORMATS.ISO_CUSTOM);

	const originSelfCutOffTime = format(newDateWithFormat(flightInfo.collectionTime, DATE_FORMATS.ISO_CUSTOM), timeFormat);
	const destinationSelfCutOffTime = format(newDateWithFormat(flightInfo.deliveryTime, DATE_FORMATS.ISO_CUSTOM), timeFormat);

	return <Section
		className={'select-address'}
		title={t('order_bill_select_delivery_method')}
		icon={<TruckIcon />}
	>

		<div className={'d-flex gap-7'}>
			<div style={{height: 197}} className={'d-flex flex-column justify-content-between'}>
				<CommonTextBlock className={'align-items-center'} text={format(departureTime, 'HH:mm')} subText={format(departureTime, 'dd/MM/yyyy')}/>
				<div className={'d-flex flex-column align-items-center'}>
					<div><img src={iconTakeOffPlaneUrl} alt={''}/></div>
					<div className={'fs-p-md lh-p-md'}>{flightInfo.flightNumber}</div>
				</div>
				<CommonTextBlock className={'align-items-center'} text={format(arrivalTime, 'HH:mm')} subText={format(arrivalTime, 'dd/MM/yyyy')}/>
			</div>
			<RoadLineIllustration/>
			<div className={'flex-grow-1 payment-method-section'}>
				<DestinationInfoBlock
					selfMethodText={`${t('order_bill_delivery_method_departure_airport_message')}:`}
					selfMethodCutOffTime={originSelfCutOffTime}
					truckMethodText={t('order_bill_delivery_method_departure_door_message')}
					airportLocation={`${i18next.language === 'vi'? flightFilter.departureAirport?.province : removeVietnameseTones(flightFilter.departureAirport?.province)} (${flightFilter.departureAirport?.key})`}
					airportName={tAirport(flightFilter.departureAirport?.name)}
					deliveryMethod={departedMethod}
					onMethodChange={val => setDepartedMethod(val)}
					className={'mb-8'}
				/>
				<DestinationInfoBlock
					selfMethodText={`${t('order_bill_delivery_method_arrival_airport_message')}:`}
					selfMethodCutOffTime={destinationSelfCutOffTime}
					truckMethodText={t('order_bill_delivery_method_arrival_door_message')}
					airportLocation={`${i18next.language === 'vi' ? flightFilter.arrivalAirport?.province : removeVietnameseTones(flightFilter.arrivalAirport?.province)} (${flightFilter.arrivalAirport?.key})`}
					airportName={tAirport(flightFilter.arrivalAirport?.name)}
					deliveryMethod={arrivalMethod}
					onMethodChange={val => setArrivalMethod(val)}
				/>
			</div>

		</div>


	</Section>
}

export default SelectDeliveryMethod